module.exports = __webpack_public_path__ + "img/88db889e4f84dc997a09f4d5cb99eddf.jpg";